import { MenuItemType } from 'interfaces/navigation.types';
import React from 'react';
import { TcolorsPaletteFromBO } from 'components/layouts/SharedHeader/types';
import { coreMenuItem } from './core';
import { StyledLink } from './styles';

type TProps = {
  menuItem: MenuItemType;
  colorsPaletteFromBO: TcolorsPaletteFromBO;
  navigate: (url: string) => void;
  setOpenMenu?: React.Dispatch<React.SetStateAction<boolean>>;
};

const index = ({
  menuItem,
  colorsPaletteFromBO,
  navigate,
  setOpenMenu,
}: TProps) => {
  const { isReactRouteActive, isExternalRouteActive } = coreMenuItem(menuItem);

  return (
    <div key={menuItem.id}>
      {menuItem.reactRoute ? (
        <StyledLink
          onClick={() => {
            navigate(menuItem.reactRoute!);
            if (setOpenMenu) {
              setOpenMenu(false);
            }
          }}
          colorsPaletteFromBO={colorsPaletteFromBO}
          key={menuItem.id}
          isCurrentUrl={isReactRouteActive}
        >
          {menuItem.label}
        </StyledLink>
      ) : (
        <StyledLink
          href={menuItem.externalRoute}
          onClick={() => setOpenMenu && setOpenMenu(false)}
          colorsPaletteFromBO={colorsPaletteFromBO}
          key={menuItem.id}
          isCurrentUrl={isExternalRouteActive}
        >
          {menuItem.label}
        </StyledLink>
      )}
    </div>
  );
};

export default index;
